import { useMutation } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { AxiosError } from 'axios';

export const destroyEmployee = async (uuid: string) => {
  if (!uuid) return null;
  await CustomAxios.delete(`employees/${uuid}`);
};

interface UseDestroyEmployeeProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useDestroyEmployee({ uuid, onSuccessCallback }: UseDestroyEmployeeProps) {
  return useMutation({
    mutationFn: () => destroyEmployee(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmployees] });

      // Call success callback
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      console.error('Error deleting employee:', err);
    }
  });
}
